import React from 'react';
import styles from './DetailsCard.module.css';

/**
 * Card branco padrão da tela "Meu plano": título, ação opcional à direita e conteúdo.
 */
const DetailsCard = ({ title, subtitle, action, children, className = '' }) => (
  <section className={`${styles.card} ${className}`}>
    {(title || action) && (
      <header className={styles.header}>
        <div className={styles.headings}>
          {title && <h2 className={styles.title}>{title}</h2>}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {action && <div className={styles.action}>{action}</div>}
      </header>
    )}
    {children}
  </section>
);

export default DetailsCard;
